import useFetch from '../../../hooks/useFetch';
import { useState } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { buildEndpoint } from '../EndPoints';

const useSimilarityAlertService = () => {
    const { doGet, doPost } = useFetch();
    
    const [fetchingGetAlerts, setFetchingGetAlerts] = useState(false);
    const [fetchingGetAlertsCount, setFetchingGetAlertsCount] = useState(false);
    const [fetchingMarkReviewed, setFetchingMarkReviewed] = useState(false);
    const [fetchingToggleMonitoring, setFetchingToggleMonitoring] = useState(false);

    /**
     * Obtiene todas las alertas de similitud con filtros
     * @param filters - Filtros opcionales (brand_registration_id, status, search, page, per_page)
     */
    const getAlerts = (filters: {
        brand_registration_id?: number;
        status?: string;
        search?: string;
        page?: number;
        per_page?: number;
    } = {}, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .filter(([_, value]) => value !== undefined && value !== '')
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        
        doGet({
            ...events,
            url: `${buildEndpoint('brand-registrations/similarity-alerts')}${queryString ? `?${queryString}` : ''}`,
            setFetching: setFetchingGetAlerts
        });
    };

    /**
     * Obtiene el contador de alertas pendientes
     * @param brandRegistrationId - Opcional, filtra por marca específica
     */
    const getAlertsCount = (brandRegistrationId?: number, events: ServiceEvents = {}) => {
        const queryString = brandRegistrationId ? `?brand_registration_id=${brandRegistrationId}` : '';
        
        doGet({
            ...events,
            url: `${buildEndpoint('brand-registrations/similarity-alerts/count')}${queryString}`,
            setFetching: setFetchingGetAlertsCount
        });
    };

    /**
     * Marca una alerta como revisada
     * @param alertId - ID de la alerta
     * @param data - Datos opcionales (status, notes)
     */
    const markAlertReviewed = (alertId: number, data: {
        status?: 'reviewed' | 'dismissed' | 'action_required';
        notes?: string;
    } = {}, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/similarity-alerts/${alertId}/review`),
            body: data,
            setFetching: setFetchingMarkReviewed
        });
    };

    /**
     * Activa o pausa el seguimiento de una marca registrada en el Diario Oficial
     */
    const toggleMonitoring = (brandRegistrationId: number, enabled: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: buildEndpoint(`brand-registrations/brand-registrations/${brandRegistrationId}/monitoring`),
            body: { enabled },
            setFetching: setFetchingToggleMonitoring
        });
    };

    return {
        getAlerts,
        toggleMonitoring,
        fetchingToggleMonitoring,
        getAlertsCount,
        markAlertReviewed,
        fetchingGetAlerts,
        fetchingGetAlertsCount,
        fetchingMarkReviewed
    };
};

export default useSimilarityAlertService;

